<script>
    import I18n from '@js/modules/translations';

    // suggestions: null = not queried yet, [] = queried empty, [...] = results.
    // available: the tool is shown as a capability; enabled: a route exists so it can run.
    const {suggestions = null, loading = false, onSuggest, available = false, enabled = false} = $props();

    // The trigger stays available so the user can re-run it after editing the route (not one-shot).
    const _triggerLabel = $derived(
        loading
            ? I18n.t('js.maps.poi_suggestions.searching')
            : (suggestions === null ? I18n.t('js.maps.poi_suggestions.suggest') : I18n.t('js.maps.poi_suggestions.search_again'))
    );
</script>

{#if available}
    <div class="map-poi-suggestions" class:map-tool-disabled={!enabled}>
        <button class="poi-suggestions-trigger"
                type="button"
                disabled={!enabled || loading}
                onclick={onSuggest}>
            {_triggerLabel}
        </button>

        <!-- The live region is the wrapper, not the message: a region inserted WITH its text in the same
             tick isn't announced, and this sentence is now the only non-visual sign the search worked. -->
        <div aria-live="polite">
            {#if !enabled}
                <p class="poi-suggestions-hint">
                    {I18n.t('js.maps.poi_suggestions.needs_route')}
                </p>
            {:else if suggestions === null}
                <p class="poi-suggestions-hint">
                    {I18n.t('js.maps.poi_suggestions.explanation')}
                </p>
            {:else if suggestions.length === 0}
                <p class="poi-suggestions-empty">
                    {I18n.t('js.maps.poi_suggestions.empty')}
                </p>
            {:else}
                <!-- The suggestions themselves are on the map: a name without a position was undecidable,
                     and the list crowded the panel on mobile. Here only the count + what to do with it. -->
                <p class="poi-suggestions-on-map">
                    {I18n.t('js.maps.poi_suggestions.on_map', {count: suggestions.length})}
                </p>
            {/if}
        </div>
    </div>
{/if}
